import PermissionClassification from '@/util/enums/PermissionClassification';

/**
 * The full set of "SupplierUpdateApprove*" permissions (27-37, Epic #4184, #6080).
 * Holding ANY one of these gates access to the Pending Approvals Inbox (#6096) and
 * the corresponding nav item / badge — a reviewer only needs approval rights for at
 * least one category to have something to review.
 */
export const SUPPLIER_UPDATE_APPROVE_PERMISSIONS: PermissionClassification[] = [
  PermissionClassification.SupplierUpdateApproveBankDetails,
  PermissionClassification.SupplierUpdateApproveTaxClearance,
  PermissionClassification.SupplierUpdateApproveTaxInformation,
  PermissionClassification.SupplierUpdateApproveCoida,
  PermissionClassification.SupplierUpdateApproveBbbee,
  PermissionClassification.SupplierUpdateApproveCompanyDetails,
  PermissionClassification.SupplierUpdateApproveContactDetails,
  PermissionClassification.SupplierUpdateApproveDocuments,
  PermissionClassification.SupplierUpdateApprovePaymentTerms,
  PermissionClassification.SupplierUpdateApproveCurrency,
  PermissionClassification.SupplierUpdateApproveErpVendorNumber
];
